import React from "react";
import { createRoot } from "react-dom/client";
import "./app.css";
import App from "./App";
import { AlertProvider } from "./contexts/AlertContext";
import { BartlettProvider } from "./contexts/BartlettContext";

const root = createRoot(document.getElementById("root")!);
root.render(
  <AlertProvider>
    <BartlettProvider>
      <App />
    </BartlettProvider>
  </AlertProvider>
);
